module.exports = __webpack_public_path__ + "static/media/21ECLAC16.086be44c.jpg";